// extracted by mini-css-extract-plugin
export default {"complianceInfoTable":"EDvCz6aHrGJOWr292Tu_","foodTitle":"Y7pWdQklQZJ8bWmfKmV7","label":"gsGSYR1re3TYIoPFF5Ca"};